/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou，haos
*/

import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { apiFetch } from '../../../apiClient';
import { apiMap } from '../../../config/constants';
import paths from '../../../config/path';
import history from '../../../utils/history';
import BasePage from '../../../shared/BasePage';
import { Grid, Button } from 'react-bootstrap';
import './style.css';

/* eslint-disable array-callback-return */
class SystemErrorMessage extends BasePage {
  constructor(props) {
    super(props);
    this.state={};

    [
      'onClickAction',
      'switchI18n',
    ].forEach((fn) => this[fn] = this[fn].bind(this));
  }

  componentDidMount() {
    this.switchI18n();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
      this.switchI18n();
    }
  };

  switchI18n = () => {
    /*
    * Fetch system error message i18n content
    */
    apiFetch(apiMap.systemErrorMessageI18n)().then((i18n) => {
      i18n && this.setState({ i18n });
    }).catch(error => {
      // console.log('systemErrorMessageI18n error ==>>', error)
    });
  };

  onClickAction = (event) => {
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    history.push(paths.logon.path);
  };

  render() {
    const { i18n } = this.state;
    return i18n ? (
      <Grid className="dynamic-form system-error-msg">
        <div className={'system-error-msg-container'}>
          <div className="error-info">
              <i className="icon icon-circle-error"></i>
              <h1 data-key="systemErrorMessage.title">
                { i18n.title }
              </h1>
              <p className="font-body1" data-key="systemErrorMessage.message">
                {i18n.msg}
              </p>
          </div>
          <div className="button-row">
              <Button bsStyle="primary" onClick={this.onClickAction}>{i18n.button}</Button>
          </div>
          </div>
      </Grid>
    ) : null
  }
}

SystemErrorMessage.propTypes = {

};

const mapStateToProps = (state) => ({
  selectedLanguage: state.app.selectedLanguage
});

export default connect(mapStateToProps, {
})(SystemErrorMessage)


// WEBPACK FOOTER //
// ./src/views/SystemErrorMessage/container/SystemErrorMessage.js